import { post } from "@/utils/request";

// 探角会员信息
export function TanMemberInfo(memberId) {
  return post('/tj/member/login', {memberId})
}